var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ConstructionTaskForm',{on:{"submit":_vm.goListPage,"cancel":_vm.goListPage}})}
var staticRenderFns = []

export { render, staticRenderFns }